import { Icon } from '@iconify/react';
import { useGet, useSet, useLastResolved } from 'ccstate-react';
import { fileExplorerState } from '../state/fileExplorerState';
import { navigateToFolder$ } from '../commands/fileCommands';
export default function Sidebar() {
    const currentFolderId = useGet(fileExplorerState.currentFolderId$);
    const navigateToFolder = useSet(navigateToFolder$);
    const storageInfo = useLastResolved(fileExplorerState.storageInfo$);
    const quickAccessItems = [
        { id: 'recent', name: 'Recent files', icon: 'lucide:clock', disabled: true },
        { id: 'starred', name: 'Starred items', icon: 'lucide:star', disabled: true },
        { id: 'shared', name: 'Shared with me', icon: 'lucide:users', disabled: true }
    ];
    const storageItems = [
        { id: 'root', name: 'My Files', icon: 'lucide:folder' },
        { id: 'documents', name: 'Documents', icon: 'lucide:file-text' },
        { id: 'images', name: 'Images', icon: 'lucide:image' },
        { id: 'videos', name: 'Videos', icon: 'lucide:video' },
        { id: 'downloads', name: 'Downloads', icon: 'lucide:download' }
    ];
    const formatStorage = (bytes: number) => {
        const gb = bytes / (1024 * 1024 * 1024);
        return `${gb.toFixed(1)} GB`;
    };
    const getUsagePercentage = () => {
        if (!storageInfo)
            return 0;
        return ((storageInfo as any).usedSpace / (storageInfo as any).totalSpace) * 100;
    };
    return (<div className="flex-shrink-0 min-w-fit max-w-xs bg-[#FAFBFD] border-r border-[#E0E7EF] h-full" data-id="dwrqej">
      <div className="p-6 flex flex-col gap-6 h-full" data-id="1iurjw">
        {/* Quick Access */}
        <div className="flex flex-col gap-3" data-id="vwfldd">
          <h3 className="text-sm font-semibold text-[#1A2B3D]" data-id="tdw5lk">Quick Access</h3>
          <div className="flex flex-col gap-1" data-id="5wdjpw">
            {quickAccessItems.map((item) => (<button key={item.id} className={`flex items-center gap-3 px-3 py-2 rounded-md text-left transition-colors ${item.disabled
                ? 'text-[#B8C1CC] cursor-not-allowed'
                : 'text-[#5A6C7D] hover:bg-[#F0F4F8] hover:text-[#4A90E2]'}`} disabled={item.disabled} data-testid={`sidebar-${item.id}`} data-id="pu4p4l">
                <Icon icon={item.icon} className="w-5 h-5" data-id="kyt7or"/>
                <span className="text-sm font-medium" data-id="ntebz3">{item.name}</span>
              </button>))}
          </div>
        </div>

        {/* Storage */}
        <div className="flex flex-col gap-3" data-id="qnn8ks">
          <h3 className="text-sm font-semibold text-[#1A2B3D]" data-id="wqmjk6">Storage</h3>
          <div className="flex flex-col gap-1" data-id="hr4dbs">
            {storageItems.map((item) => (<button key={item.id} onClick={() => navigateToFolder(item.id)} className={`flex items-center gap-3 px-3 py-2 rounded-md text-left transition-colors ${currentFolderId === item.id
                ? 'bg-[#E8F2FC] text-[#4A90E2]'
                : 'text-[#5A6C7D] hover:bg-[#F0F4F8] hover:text-[#4A90E2]'}`} data-testid={`sidebar-${item.id}`} data-id="pakqfp">
                <Icon icon={item.icon} className="w-5 h-5" data-id="b9u2pe"/>
                <span className="text-sm font-medium" data-id="l02q2d">{item.name}</span>
              </button>))}
          </div>
        </div>

        {/* Storage Usage */}
        <div className="flex flex-col gap-3 mt-auto" data-id="avgqfl">
          <div className="px-3 py-4 bg-white rounded-lg border border-[#E0E7EF]" data-id="9phy55">
            <div className="flex items-center gap-2 mb-3" data-id="lalrr8">
              <Icon icon="lucide:hard-drive" className="w-4 h-4 text-[#5A6C7D]" data-id="lqh5t6"/>
              <span className="text-sm font-medium text-[#1A2B3D]" data-id="ra2xkr">Storage</span>
            </div>

            {storageInfo && (<>
                <div className="mb-2" data-id="hplxli">
                  <div className="h-1.5 bg-[#E0E7EF] rounded-full overflow-hidden" data-id="5ukxc4">
                    <div className="h-full bg-[#4A90E2] rounded-full transition-all" style={{ width: `${getUsagePercentage()}%` }} data-id="44zx6f"/>
                  </div>
                </div>

                <div className="text-xs text-[#8B99A8]" data-id="pk5j5b">
                  {formatStorage((storageInfo as any).usedSpace)} of {formatStorage((storageInfo as any).totalSpace)} used
                </div>
              </>)}
          </div>
        </div>
      </div>
    </div>);
}
